import axios from "axios";

// Determine API base URL:
// - If REACT_APP_API_URL (or REACT_APP_API_BASE_URL) is set, use it.
// - In development we use /api so Create React App's proxy (see package.json "proxy") forwards to the backend.
// - In production the same-origin /api is served by the Express server.
const defaultApiUrl =
  process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE_URL;

axios.defaults.baseURL = defaultApiUrl || "/api";
axios.defaults.withCredentials = true;

